export default "__VITE_ASSET__4rW4wMtV__"